import * as React from "react";
import {inject} from "mobx-react";

import {ClipsFullscreenStore} from "../../../../lib/ClipsFullscreenStore";

import {BottomSheet} from "@ok/web/components/base/BottomSheet/BottomSheet";

import {copy as copyTextToClipboard} from "@ok/web/utils/clipboard";
import {ButtonCellAction, ButtonCellActionCopyLink, ButtonInline} from "@ok/common/design-system";
import {AnonymControlWrapper} from "../../common/controls/AnonymControlWrapper";
import {Clip, CLIP_URLS, ToastType} from "../../../../lib/types";
import {DataL} from "@ok/web/utils/DataL";
import {l10n} from "@ok/web/modules/l10n/l10n";

const l10NPkg = l10n("clips");

interface IReshare {
    bean: Clip;
    store?: ClipsFullscreenStore;
}
export const Reshare: React.FC<IReshare> = inject("store")((props): React.ReactElement => {
    const store = props.store!;
    const authorInfo = props.bean.payload.authorInfo;
    const clipId = props.bean.meta.movie.id;

    const [isBottomSheetOpen, setIsBottomSheetOpen] = React.useState(false);

    const handleCopyLink = React.useCallback(() => {
        copyTextToClipboard(store.getLinkOnCurrentClip1())
            .then(() => {
                setIsBottomSheetOpen(false);
                store.setShowToast(ToastType.LINK_COPIED);
            });
    }, [store]);

    const handleReshareNow = React.useCallback(() => {
        store.doRequest(CLIP_URLS.RESHARE);
        setIsBottomSheetOpen(false);
    }, [store]);

    const handleClick = React.useCallback(() => {
        if (!store.isAnonym) {
            setIsBottomSheetOpen(true);
        }
    }, [store]);

    const logAttr = DataL.attr({
        target: "VK_CLIPS_LIST_CLIP_SHARE_CLICK",
        clipId: clipId,
        ownerId: authorInfo.id,
        position: store.currentItemIndex
    });

    return (
        <AnonymControlWrapper>
            <ButtonInline
                data-tsid={"clip-open-reshare-bottom-sheet"}
                size={"32"}
                view={"primary-on-color"}
                aria-label={l10NPkg.getLMsg("reshareNow")}
                onClick={handleClick}
                {...logAttr}
            >
                <ButtonInline.LeftIcon
                    icon={"glyph_reshare_24+"}
                />
            </ButtonInline>


            <BottomSheet
                withPadding={true}
                open={isBottomSheetOpen}
                portalClassName={"clips-fullscreen"}
                onClose={() => setIsBottomSheetOpen(false)}
            >
                <ButtonCellActionCopyLink label={l10NPkg.getLMsg("copyLiknk")} onClick={handleCopyLink}/>
                <ButtonCellAction
                    onClick={handleReshareNow}
                    view={"secondary"}
                >
                    <ButtonCellAction.LeftIcon icon="glyph_reshare_24+"/>
                    <ButtonCellAction.Label>
                        {l10NPkg.getLMsg("reshareNow")}
                    </ButtonCellAction.Label>
                </ButtonCellAction>
            </BottomSheet>
        </AnonymControlWrapper>
    );
});
